import React from 'react'
import Mainlayout from '../../Layout/PageLayout/Mainlayout'
import OtpVerify from '../../Forms/Verify/OtpVerify'
const Verify = () => {
  return (
    <OtpVerify />
  )
}

export default Mainlayout(Verify)